import React from 'react'

//components
import loginAnotherWay from '../containers/Login/LoginAnotherWay'
import StaffLogin from '../containers/Login/StaffLogin'
import LoginComponent from '../containers/Login/Login'
import RegisterComponent from '../containers/SignUp/Register'
import PatientDetail from '../containers/SignUp/PatientDetail'
import VerifyEmail from '../containers/VerifyEmail'
import SignUpLink from '../containers/SignUp/SignUpLink'
import SignUp from '../containers/SignUp/SignUpForm'
import { authNotRequired, authRequired } from '../utilities/guards'
import Routes from '../constants/routes'
import PatientBookAppointment from '../containers/Appointments/PatientBookAppointment'
import { Redirect } from 'react-router-dom'
import MainIndex from '../components/Consultation/MainIndex'
import Dashboard from '../containers/Dashboard'
import { getAllUserRoles } from '../constants/user-roles'
import SignInContainer from '../containers/SignIn/SignIn'
import ForgotPasswordContainer from '../containers/SignIn/ForgotPassword'
import MagicLinkContainer from '../containers/SignIn/MagicLink'
import PatientIdMagicLinkContainer from '../containers/SignIn/PatientIdMagicLink'
import HealthReport from '../components/HealthReport'
import HealthConditions from '../components/HeathConditions'
import ClinicalNotes from '../components/ClinicalNotesGuest/index'
import LabResults from '../components/LabResults'
import MedicationAllergies from '../components/MedicationAllergies'
import Medications from '../components/Medications'
import AppointmentNew from '../components/AppointmentNew'
import MessageCareTeam from '../components/MessageCareTeam'
import Contacts from '../components/Contacts'

const meta = {
    auth: false,
    guards: [authNotRequired],
}

const guestRoutes = [
    {
        path: [Routes.HOME],
        // eslint-disable-next-line react/display-name
        component: () => <Redirect to={Routes.SIGNIN}></Redirect>,
        meta,
    },
    {
        path: [Routes.PATAIENTBOOKAPPOINTMENT],
        component: PatientBookAppointment,
        meta,
    },
    {
        path: [Routes.SIGNIN],
        component: PatientIdMagicLinkContainer,
        meta,
    },
    {
        path: [Routes.MAGIC_LINK],
        component: MagicLinkContainer,
        meta,
    },
    {
        path: '*',
        // eslint-disable-next-line react/display-name
        component: () => <Redirect to={Routes.SIGNIN}></Redirect>,
        meta,
    },
]

export default guestRoutes
